import React from "react";
import { ITag } from "../../../../models/tags/TagsStore";
import { Chip, Props as ChipProps } from "../../Chip";
import styles from "./ChipTag.css";

type Props = Pick<ITag, "name" | "enabled"> & Partial<ChipProps>;

export const ChipTag = ({ name, enabled, ...rest }: Props) => {
  return (
    <Chip label={name} className={enabled ? styles.chip : styles["chip-inactive"]} {...rest} />
  );
};
